export const gerundInfinitiveQuestions = [
  {
    id: 1,
    koreanQuestion: "그녀는 즐긴다 ____  소설을 그녀의 여가시간에",
    question: "She enjoys _____ novels in her free time.",
    choices: {
      A: "read",
      B: "to read",
      C: "reading",
      D: "reads",
    },
    correctAnswer: "C",
    explanation:
      "A: '읽다'라는 동사 원형으로, 'enjoy' 뒤에는 동명사가 와야 합니다. B: '읽기 위해'라는 의미의 부정사로, 'enjoy' 뒤에는 적절하지 않습니다. C: '읽는 것'이라는 의미의 동명사로, 'enjoy'와 같은 동사(appreciate, mind, finish 등) 뒤에는 동명사가 옵니다. 'enjoy'는 이미 진행 중이거나 경험한 것, 일반적인 활동에 대해 사용됩니다. D: '읽는다'라는 의미의 3인칭 단수 현재형으로, 문법적으로 맞지 않습니다.",

    translation: "그녀는 여가 시간에 소설 읽는 것을 즐긴다.",
    type: "gerund-infinitive",
  },
  {
    id: 2,
    koreanQuestion:
      "그 회사는 결정했다 ____  새로운 마케팅 전략을 증가시키기 위해 매출을",
    question:
      "The company decided _____ a new marketing strategy to increase sales.",
    choices: {
      A: "implementing",
      B: "implement",
      C: "to implement",
      D: "implemented",
    },
    correctAnswer: "C",
    explanation:
      "A: '실행하는 것'이라는 의미의 동명사로, 'decide' 뒤에는 부정사가 와야 합니다. B: '실행하다'라는 동사 원형으로, 'decide' 뒤에는 부정사 형태가 필요합니다. C: '실행하기 위해'라는 의미의 부정사로, 'decide'와 같은 동사(plan, hope, want 등) 뒤에는 부정사가 옵니다. 'decide'는 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다. D: '실행된'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "그 회사는 매출을 증가시키기 위해 새로운 마케팅 전략을 실행하기로 결정했다.",
    type: "gerund-infinitive",
  },
  {
    id: 3,
    koreanQuestion: "그 매니저는 동의했다 _____  새로운 제안을 긴 토론 후에",
    question:
      "The manager agreed _____ the new proposal after a long discussion.",
    choices: {
      A: "considering",
      B: "to consider",
      C: "considered",
      D: "consider",
    },
    correctAnswer: "B",
    explanation:
      "A: '고려하는 것'이라는 의미의 동명사로, 'agree' 뒤에는 부정사가 와야 합니다. B: '고려하기 위해'라는 의미의 부정사로, 'agree'와 같은 동사(promise, plan, decide 등) 뒤에는 부정사가 옵니다. 'agree'는 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다. C: '고려된'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다. D: '고려하다'라는 동사 원형으로, 'agree' 뒤에는 부정사 형태가 필요합니다.",
    translation: "그 매니저는 긴 토론 후에 새로운 제안을 고려하기로 동의했다.",
    type: "gerund-infinitive",
  },
  {
    id: 4,
    koreanQuestion: "그 회사는 기대한다 ___  이윤 증가를  다음 분기에",
    question:
      "The company expects _____ a profit increase in the next quarter.",
    choices: {
      A: "seeing",
      B: "see",
      C: "to see",
      D: "seen",
    },
    correctAnswer: "C",
    explanation:
      "A: '보는 것'이라는 의미의 동명사로, 'expect' 뒤에는 부정사가 와야 합니다. B: '보다'라는 동사 원형으로, 'expect' 뒤에는 부정사 형태가 필요합니다. C: '보기 위해'라는 의미의 부정사로, 'expect'와 같은 동사(hope, want, plan 등) 뒤에는 부정사가 옵니다. 'expect'는 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다. D: '본'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "그 회사는 다음 분기에 이윤 증가를 보게 될 것으로 기대한다.",
    type: "gerund-infinitive",
  },
  {
    id: 5,
    koreanQuestion:
      "그 직원은 실패했다 _____ 마감일을 예상치 못한 문제들 때문에",
    question:
      "The employee failed _____ the deadline due to unexpected issues.",
    choices: {
      A: "meeting",
      B: "meet",
      C: "to meet",
      D: "met",
    },
    correctAnswer: "C",
    explanation:
      "A: '만나는 것'이라는 의미의 동명사로, 'fail' 뒤에는 부정사가 와야 합니다. B: '만나다'라는 동사 원형으로, 'fail' 뒤에는 부정사 형태가 필요합니다. C: '만나기 위해'라는 의미의 부정사로, 'fail'과 같은 동사(attempt, manage, struggle 등) 뒤에는 부정사가 옵니다. 'fail'은 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다. D: '만난'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "그 직원은 예상치 못한 문제들 때문에 마감일을 맞추는 데 실패했다.",
    type: "gerund-infinitive",
  },
  {
    id: 6,
    koreanQuestion: "경영진은 희망한다 _____  성공적인 제품 출시 다음 달에",
    question:
      "The management hopes _____ a successful product launch next month.",
    choices: {
      A: "achieving",
      B: "to achieve",
      C: "achieved",
      D: "achieve",
    },
    correctAnswer: "B",
    explanation: "아직 이루지 않은 목표, 의도, 미래 지향적인 것 = to 부정사",
    translation: "경영진은 다음 달에 성공적인 제품 출시를 이루기를 희망한다.",
    type: "gerund-infinitive",
  },
  {
    id: 7,
    koreanQuestion:
      "직원들은 열망한다 ____ 새로운 기술을 향상시키기 위해 생산성을",
    question:
      "The employees are eager _____ new skills to improve productivity.",
    choices: {
      A: "learning",
      B: "learn",
      C: "learned",
      D: "to learn",
    },
    correctAnswer: "D",
    explanation:
      "A: '배우는 것'이라는 의미의 동명사로, 'eager' 뒤에는 부정사가 와야 합니다. B: '배우다'라는 동사 원형으로, 'eager' 뒤에는 부정사 형태가 필요합니다. C: '배운'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다. D: '배우기 위해'라는 의미의 부정사로, 'eager'와 같은 형용사 뒤에는 부정사가 옵니다. 'eager'는 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다.",
    translation:
      "직원들은 생산성을 향상시키기 위해 새로운 기술을 배우기를 열망한다.",
    type: "gerund-infinitive",
  },
  {
    id: 8,
    koreanQuestion: "어려움에도 불구하고, 그는 해냈다 _____  프로젝트를 정시에",
    question: "Despite the difficulties, he managed _____ the project on time.",
    choices: {
      A: "completing",
      B: "complete",
      C: "to complete",
      D: "completed",
    },
    correctAnswer: "C",
    explanation:
      "A: '완료하는 것'이라는 의미의 동명사로, 'manage' 뒤에는 부정사가 와야 합니다. B: '완료하다'라는 동사 원형으로, 'manage' 뒤에는 부정사 형태가 필요합니다. C: '완료하기 위해'라는 의미의 부정사로, 'manage'와 같은 동사(attempt, fail, struggle 등) 뒤에는 부정사가 옵니다. 'manage'는 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다. D: '완료된'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "어려움에도 불구하고, 그는 프로젝트를 정시에 완료하는 데 성공했다.",
    type: "gerund-infinitive",
  },
  {
    id: 9,
    koreanQuestion: "그 회사는 제안했다  _____ 추가 교육 세션을  직원들을 위해",
    question:
      "The company offered _____ additional training sessions for employees.",
    choices: {
      A: "providing",
      B: "to provide",
      C: "provided",
      D: "provide",
    },
    correctAnswer: "B",
    explanation:
      "A: '제공하는 것'이라는 의미의 동명사로, 'offer' 뒤에는 부정사가 와야 합니다. B: '제공하기 위해'라는 의미의 부정사로, 'offer'와 같은 동사(promise, agree, decide 등) 뒤에는 부정사가 옵니다. 'offer'는 아직 이루지 않은 목표나 의도, 미래 지향적인 행동에 대해 사용됩니다. C: '제공된'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다. D: '제공하다'라는 동사 원형으로, 'offer' 뒤에는 부정사 형태가 필요합니다.",
    translation:
      "그 회사는 직원들을 위해 추가 교육 세션을 제공하기로 제안했다.",
    type: "gerund-infinitive",
  },
  {
    id: 10,
    koreanQuestion: "그 회사는 계획한다 _____ 새로운 지점을 아시아에 내년에",
    question: "The company plans _____ a new branch in Asia next year.",
    choices: {
      A: "opening",
      B: "open",
      C: "to open",
      D: "opened",
    },
    correctAnswer: "C",
    explanation: "아직 이루지 않은 목표, 의도, 미래 지향적인 것 = to 부정사",
    translation: "그 회사는 내년에 아시아에 새로운 지점을 열 계획이다.",
    type: "gerund-infinitive",
  },
  {
    id: 11,
    koreanQuestion:
      "그는 가장했다 ____ 관심있는 회의에, 하지만 그는 실제로 지루했다",
    question:
      "He pretended _____ interested in the meeting, but he was actually bored.",
    choices: {
      A: "being",
      B: "be",
      C: "to be",
      D: "been",
    },
    correctAnswer: "C",
    explanation:
      "A: '관심있는 것'이라는 의미의 동명사로, 'pretend' 뒤에는 부정사가 와야 합니다. B: '관심있다'라는 동사 원형으로, 'pretend' 뒤에는 부정사 형태가 필요합니다. C: '관심있는 척하기 위해'라는 의미의 부정사로, 'pretend'와 같은 동사(claim, appear 등) 뒤에는 부정사가 옵니다. 'pretend'는 가장하는 행동에 대해 사용됩니다. D: '관심있었던'이라는 의미의 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "그는 회의에 관심이 있는 척했지만, 실제로는 지루했다.",
    type: "gerund-infinitive",
  },
  {
    id: 12,
    koreanQuestion:
      "직원들 그.. 재택근무하는 경향이 있다 ____ 더 오랜 시간을 직원들보다 사무실에 있는",
    question:
      "Employees who work remotely tend _____ longer hours than those in the office.",
    choices: {
      A: "working",
      B: "to work",
      C: "work",
      D: "worked",
    },
    correctAnswer: "B",
    explanation:
      "A: 'working'은 동명사 형태로, 'tend' 뒤에는 부정사가 와야 합니다. B: 'to work'는 부정사 형태로, 'tend'와 같은 동사(appear, seem 등) 뒤에는 부정사가 옵니다. 'tend'는 경향이나 습관을 나타낼 때 사용됩니다. C: 'work'는 동사 원형으로, 'tend' 뒤에는 부정사 형태가 필요합니다. D: 'worked'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "재택근무하는 직원들은 사무실 직원들보다 더 오래 일하는 경향이 있다.",
    type: "gerund-infinitive",
  },
  {
    id: 13,
    koreanQuestion:
      "그 회사는 시도했다 _____ 새로운 가격 모델을 유치하기 위해 더 많은 고객을 ",
    question:
      "The company attempted _____ a new pricing model to attract more customers.",
    choices: {
      A: "implementing",
      B: "to implement",
      C: "implement",
      D: "implemented",
    },
    correctAnswer: "B",
    explanation:
      "A: 'implementing'은 동명사 형태로, 'attempt' 뒤에는 부정사가 와야 합니다. B: 'to implement'는 부정사 형태로, 'attempt'와 같은 동사(try, plan 등) 뒤에는 부정사가 옵니다. 'attempt'는 시도하는 행동에 대해 사용되며, 아직 이루지 않은 목표나 의도를 나타낼 때는 to 부정사가 적절합니다. C: 'implement'는 동사 원형으로, 'attempt' 뒤에는 부정사 형태가 필요합니다. D: 'implemented'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "그 회사는 더 많은 고객을 유치하기 위해 새로운 가격 모델을 도입하려고 시도했다.",
    type: "gerund-infinitive",
  },
  {
    id: 14,
    koreanQuestion:
      "신중한 계획에도 불구하고, 팀은 실패했다 ____ 프로젝트 마감일을",
    question:
      "Despite careful planning, the team failed _____ the project deadline.",
    choices: {
      A: "meeting",
      B: "to meet",
      C: "meet",
      D: "met",
    },
    correctAnswer: "B",
    explanation:
      "A: 'meeting'은 동명사 형태로, 'fail' 뒤에는 부정사가 와야 합니다. B: 'to meet'는 부정사 형태로, 'fail'과 같은 동사(forget, manage 등) 뒤에는 부정사가 옵니다. 'fail'은 실패한 행동에 대해 사용되며, 아직 이루지 않은 목표나 의도를 나타낼 때는 to 부정사가 적절합니다. C: 'meet'는 동사 원형으로, 'fail' 뒤에는 부정사 형태가 필요합니다. D: 'met'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "신중한 계획에도 불구하고, 팀은 프로젝트 마감일을 맞추는 데 실패했다.",
    type: "gerund-infinitive",
  },
  {
    id: 15,
    koreanQuestion:
      "그 회사는 작정이다 ____  추가 직원을 처리하기 위해 늘어난 업무량을 ",
    question:
      "The company means _____ additional staff to handle the increased workload.",
    choices: {
      A: "hiring",
      B: "to hire",
      C: "hire",
      D: "hired",
    },
    correctAnswer: "B",
    explanation: "아직 이루지 않은 목표, 의도, 미래 지향적인 것 = to 부정사",
    translation:
      "그 회사는 늘어난 업무량을 처리하기 위해 추가 직원을 고용할 작정이다.",
    type: "gerund-infinitive",
  },
  {
    id: 16,
    koreanQuestion:
      "매니저는 조언했다 직원들에게 피하라고 _____  민감한 정보를 공공장소에서",
    question:
      "The manager advised employees to avoid _____ sensitive information in public.",
    choices: {
      A: "discussing",
      B: "discuss",
      C: "to discuss",
      D: "discussed",
    },
    correctAnswer: "A",
    explanation:
      "A: 'discussing'은 동명사 형태로, 'avoid' 뒤에는 동명사가 옵니다. 'avoid'와 같은 동사(enjoy, finish, consider 등) 뒤에는 동명사가 와야 합니다. B: 'discuss'는 동사 원형으로, 'avoid' 뒤에는 동명사 형태가 필요합니다. C: 'to discuss'는 부정사 형태로, 'avoid' 뒤에는 동명사가 와야 합니다. D: 'discussed'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "매니저는 직원들에게 공공장소에서 민감한 정보를 논의하는 것을 피하라고 조언했다.",
    type: "gerund-infinitive",
  },
  {
    id: 17,
    koreanQuestion:
      "그 회사는 고려하는 중이다 ____  새로운 지점을 남아메리카에",
    question: "The company is considering _____ a new branch in South America.",
    choices: {
      A: "open",
      B: "opening",
      C: "to open",
      D: "opened",
    },
    correctAnswer: "B",
    explanation:
      "A: 'open'은 동사 원형으로, 'considering' 뒤에는 동명사가 필요합니다. B: 'opening'은 동명사 형태로, 'consider'와 같은 동사(enjoy, finish, mind 등) 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 사용합니다. C: 'to open'은 부정사 형태로, 'consider' 뒤에는 동명사가 와야 합니다. D: 'opened'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "그 회사는 남아메리카에 새로운 지점을 여는 것을 고려하고 있다.",
    type: "gerund-infinitive",
  },
  {
    id: 18,
    koreanQuestion: "많은 관광객들은 즐긴다 _____ 현지 음식을 여행 중에 해외로",
    question: "Many tourists enjoy _____ local cuisine when traveling abroad.",
    choices: {
      A: "try",
      B: "to try",
      C: "trying",
      D: "tried",
    },
    correctAnswer: "C",
    explanation:
      "A: 'try'는 동사 원형으로, 'enjoy' 뒤에는 동명사가 필요합니다. B: 'to try'는 부정사 형태로, 'enjoy' 뒤에는 동명사가 와야 합니다. C: 'trying'은 동명사 형태로, 'enjoy'와 같은 동사(consider, finish, mind 등) 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 사용합니다. D: 'tried'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "많은 관광객들은 해외여행 중에 현지 음식을 시도하는 것을 즐긴다.",
    type: "gerund-infinitive",
  },
  {
    id: 19,
    koreanQuestion: "직원들은 끝냈다 ____  연간 보고서를 바로 마감 직전에",
    question:
      "The employees finished _____ the annual report just before the deadline.",
    choices: {
      A: "prepare",
      B: "to prepare",
      C: "preparing",
      D: "prepared",
    },
    correctAnswer: "C",
    explanation:
      "A: 'prepare'는 동사 원형으로, 'finish' 뒤에는 동명사가 필요합니다. B: 'to prepare'는 부정사 형태로, 'finish' 뒤에는 동명사가 와야 합니다. C: 'preparing'은 동명사 형태로, 'finish'와 같은 동사(enjoy, consider, mind 등) 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 사용합니다. D: 'prepared'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation: "직원들은 마감 직전에 연간 보고서 준비를 끝냈다.",
    type: "gerund-infinitive",
  },
  {
    id: 20,
    koreanQuestion: "당신은 꺼리시나요 ____ 창문을 ? 추워지고 있어요 이곳이",
    question: "Would you mind _____ the window? It's getting cold in here.",
    choices: {
      A: "close",
      B: "to close",
      C: "closing",
      D: "closed",
    },
    correctAnswer: "C",
    explanation:
      "A: 'close'는 동사 원형으로, 'mind' 뒤에는 동명사가 필요합니다. B: 'to close'는 부정사 형태로, 'mind' 뒤에는 동명사가 와야 합니다. C: 'closing'은 동명사 형태로, 'mind'와 같은 동사(enjoy, consider, finish 등) 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 사용합니다. D: 'closed'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation: "창문을 닫아주시겠습니까? 여기가 추워지고 있어서요.",
    type: "gerund-infinitive",
  },
  {
    id: 21,
    koreanQuestion:
      "그 컨설턴트는 제안했다 ______ 새로운 마케팅 접근법을 유치하기 위해 더 젊은 고객들을",
    question:
      "The consultant suggested _____ a new marketing approach to attract younger customers.",
    choices: {
      A: "implementing",
      B: "implement",
      C: "to implement",
      D: "implemented",
    },
    correctAnswer: "A",
    explanation:
      "이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 제안하는 상황에서는, 그 제안이 이미 진행중인 생각이라고 외우면 쉽습니다. ",
    translation:
      "그 컨설턴트는 젊은 고객들을 유치하기 위해 새로운 마케팅 접근법을 실행하는 것을 제안했다.",
    type: "gerund-infinitive",
  },
  {
    id: 22,
    koreanQuestion: "그 직원은 인정했다 ____ 실수를  재무 보고서에서",
    question: "The employee admitted _____ a mistake in the financial report.",
    choices: {
      A: "making",
      B: "make",
      C: "to make",
      D: "made",
    },
    correctAnswer: "A",
    explanation:
      "A: 'making'은 동명사 형태로, 'admit'과 같은 동사(deny, avoid, consider 등) 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'make'는 동사 원형으로, 'admit' 뒤에는 동명사가 필요합니다. C: 'to make'는 부정사 형태로, 'admit' 뒤에는 동명사가 와야 합니다. D: 'made'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation: "그 직원은 재무 보고서에서 실수를 했다는 것을 인정했다.",
    type: "gerund-infinitive",
  },
  {
    id: 23,
    koreanQuestion: "그 용의자는 부인했다 ____  어떤 관련을 그 사기 사건에",
    question: "The suspect denied _____ any involvement in the fraud case.",
    choices: {
      A: "having",
      B: "have",
      C: "to have",
      D: "had",
    },
    correctAnswer: "A",
    explanation:
      "A: 'having'은 동명사 형태로, 'deny'와 같은 동사(admit, avoid, consider 등) 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'have'는 동사 원형으로, 'deny' 뒤에는 동명사가 필요합니다. C: 'to have'는 부정사 형태로, 'deny' 뒤에는 동명사가 와야 합니다. D: 'had'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation: "그 용의자는 그 사기 사건에 어떤 관련이 있다는 것을 부인했다.",
    type: "gerund-infinitive",
  },
  {
    id: 24,
    koreanQuestion: "그 매니저는 결정했다 미루기로  _____ 회의를 다음 주까지",
    question:
      "The manager decided to postpone _____ the meeting until next week.",
    choices: {
      A: "scheduling",
      B: "schedule",
      C: "to schedule",
      D: "scheduled",
    },
    correctAnswer: "A",
    explanation:
      "A: 'scheduling'은 동명사 형태로, 'postpone' 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'schedule'은 동사 원형으로, 'postpone' 뒤에는 동명사가 필요합니다. C: 'to schedule'은 부정사 형태로, 'postpone' 뒤에는 동명사가 와야 합니다. D: 'scheduled'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "그 매니저는 회의 일정 잡기를 다음 주로 미루기로 결정했다.",
    type: "gerund-infinitive",
  },
  {
    id: 25,
    koreanQuestion:
      "그녀는 연습한다 ____ 영어를 매일 향상시키기 위해 그녀의 유창성을 ",
    question: "She practices _____ English every day to improve her fluency.",
    choices: {
      A: "speaking",
      B: "speak",
      C: "to speak",
      D: "spoken",
    },
    correctAnswer: "A",
    explanation:
      "A: 'speaking'은 동명사 형태로, 'practice'와 같은 동사 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'speak'는 동사 원형으로, 'practice' 뒤에는 동명사가 필요합니다. C: 'to speak'는 부정사 형태로, 'practice' 뒤에는 동명사가 와야 합니다. D: 'spoken'은 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "그녀는 유창성을 향상시키기 위해 매일 영어 말하기를 연습한다.",
    type: "gerund-infinitive",
  },
  {
    id: 26,
    koreanQuestion:
      "높은 연봉에도 불구하고, 그녀는 거부했다 _____ 그 일자리 제안을",
    question: "Despite the high salary, she resisted _____ the job offer.",
    choices: {
      A: "accepting",
      B: "accept",
      C: "to accept",
      D: "accepted",
    },
    correctAnswer: "A",
    explanation:
      "A: 'accepting'은 동명사 형태로, 'resist' 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'accept'는 동사 원형으로, 'resist' 뒤에는 동명사가 필요합니다. C: 'to accept'는 부정사 형태로, 'resist' 뒤에는 동명사가 와야 합니다. D: 'accepted'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "높은 연봉에도 불구하고, 그녀는 그 일자리 제안을 받아들이는 것을 거부했다.",
    type: "gerund-infinitive",
  },
  {
    id: 27,
    koreanQuestion: "그는 감수했다 _____  많은 돈을 주식 시장에서",
    question: "He risked _____ a lot of money in the stock market.",
    choices: {
      A: "losing",
      B: "lose",
      C: "to lose",
      D: "lost",
    },
    correctAnswer: "A",
    explanation:
      "A: 'losing'은 동명사 형태로, 'risk' 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'lose'는 동사 원형으로, 'risk' 뒤에는 동명사가 필요합니다. C: 'to lose'는 부정사 형태로, 'risk' 뒤에는 동명사가 와야 합니다. D: 'lost'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "그는 주식 시장에서 많은 돈을 잃을 위험을 감수했다.",
    type: "gerund-infinitive",
  },
  {
    id: 28,
    koreanQuestion:
      "매니저는 조언했다 직원들에게 유지하라고 ______ 그들의 일을 어려움에도 불구하고",
    question:
      "The manager advised the employees to keep _____ their work despite the challenges.",
    choices: {
      A: "improving",
      B: "improve",
      C: "to improve",
      D: "improved",
    },
    correctAnswer: "A",
    explanation:
      "A: 'improving'은 동명사 형태로, 'keep' 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'improve'는 동사 원형으로, 'keep' 뒤에는 동명사가 필요합니다. C: 'to improve'는 부정사 형태로, 'keep' 뒤에는 동명사가 와야 합니다. D: 'improved'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "매니저는 직원들에게 어려움에도 불구하고 그들의 일을 계속 개선하라고 조언했다.",
    type: "gerund-infinitive",
  },
  {
    id: 29,
    koreanQuestion:
      "그는 결심했다 그만두기로 ______  늦게 밤에 그리고 집중하기로 그의 건강에",
    question: "He decided to quit _____ late at night and focus on his health.",
    choices: {
      A: "working",
      B: "work",
      C: "to work",
      D: "worked",
    },
    correctAnswer: "A",
    explanation:
      "A: 'working'은 동명사 형태로, 'quit' 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'work'는 동사 원형으로, 'quit' 뒤에는 동명사가 필요합니다. C: 'to work'는 부정사 형태로, 'quit' 뒤에는 동명사가 와야 합니다. D: 'worked'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "그는 건강에 집중하기 위해 늦게까지 일하는 것을 그만두기로 결심했다.",
    type: "gerund-infinitive",
  },
  {
    id: 30,
    koreanQuestion: "그 회사는 미뤘다 ____ 새로운 제품을 기술적 문제들 때문에",
    question:
      "The company delayed _____ the new product due to technical issues.",
    choices: {
      A: "launching",
      B: "launch",
      C: "to launch",
      D: "launched",
    },
    correctAnswer: "A",
    explanation:
      "A: 'launching'은 동명사 형태로, 'delay' 뒤에는 동명사가 옵니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. B: 'launch'는 동사 원형으로, 'delay' 뒤에는 동명사가 필요합니다. C: 'to launch'는 부정사 형태로, 'delay' 뒤에는 동명사가 와야 합니다. D: 'launched'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "그 회사는 기술적 문제들 때문에 새로운 제품 출시를 연기했다.",
    type: "gerund-infinitive",
  },
  {
    id: 31,
    koreanQuestion:
      "그 회사는 의도한다 _____ 새로운 제품 라인 충족시키기 위해 고객 수요를 ",
    question:
      "The company intends _____ a new product line to meet customer demand.",
    choices: {
      A: "launching",
      B: "launch",
      C: "to launch",
      D: "launched",
    },
    correctAnswer: "C",
    explanation:
      "C: 'to launch'는 부정사 형태로, 'intend' 뒤에는 부정사가 옵니다. 아직 이루지 않은 목표, 의도, 미래 지향적인 것은 부정사를 씁니다. A: 'launching'은 동명사 형태로, 'intend' 뒤에는 부정사가 필요합니다. B: 'launch'는 동사 원형으로, 'intend' 뒤에는 부정사가 필요합니다. D: 'launched'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "그 회사는 고객 수요를 충족시키기 위해 새로운 제품 라인을 출시할 의도이다.",
    type: "gerund-infinitive",
  },

  {
    id: 32,
    koreanQuestion:
      "매니저는 잊었다 _____  고객에게 이메일을 , 그래서 그는 보냈다 이메일을 나중에 그날에.",
    question:
      "The manager forgot ______ the client an email, so he sent it later that day.",
    choices: {
      A: "to send",
      B: "sending",
      C: "send",
      D: "sends",
    },
    correctAnswer: "A",
    explanation:
      "A: 'to send'는 부정사 형태로, 'forget' 뒤에는 부정사가 옵니다. 이 문맥에서는 매니저가 이메일을 보내는 것을 잊었다는 의미로, 아직 이루어지지 않은 행동에 대해 부정사를 사용합니다. B: 'sending'은 동명사 형태로, 'forget' 뒤에 동명사가 오면 '이미 한 일을 잊었다'는 의미가 됩니다. C: 'send'는 동사 원형으로, 'forget' 뒤에는 부정사가 필요합니다. D: 'sends'는 3인칭 단수 현재형으로, 문법적으로 맞지 않습니다.",
    translation: "아직 이루지 않은 목표, 의도, 미래 지향적인 것 = to 부정사",
    type: "gerund-infinitive",
  },
  {
    id: 33,
    koreanQuestion:
      "CEO는 멈췄다 ____ 중요성을 데이터 보안 마무리하기 전에 그의 발표를",
    question:
      "The CEO stopped ______ the importance of data security before concluding his presentation.",
    choices: {
      A: "to emphasize",
      B: "emphasizing",
      C: "emphasize",
      D: "emphasized",
    },
    correctAnswer: "A",
    explanation:
      "A: 'to emphasize'는 부정사 형태로, 'stop' 뒤에 부정사가 오면 '~하기 위해 멈추다'라는 의미가 됩니다. 이 문맥에서는 CEO가 데이터 보안의 중요성을 강조하기 위해 발표 중간에 멈췄다는 의미입니다. B: 'emphasizing'은 동명사 형태로, 'stop' 뒤에 동명사가 오면 '~하는 것을 멈추다'라는 의미가 됩니다. C: 'emphasize'는 동사 원형으로, 'stop' 뒤에는 부정사나 동명사가 필요합니다. D: 'emphasized'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "CEO는 발표를 마무리하기 전에 데이터 보안의 중요성을 강조하기 위해 멈췄다.",
    type: "gerund-infinitive",
  },
  {
    id: 34,
    koreanQuestion:
      "증가하는것 예산을 의미한다 ____ 추가 직원을  프로젝트를 위해 ",
    question:
      "Increasing the budget means ______ additional staff for the project.",
    choices: {
      A: "to hire",
      B: "hiring",
      C: "hire",
      D: "hired",
    },
    correctAnswer: "B",
    explanation:
      "B: 'hiring'은 동명사 형태입니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 추가 직원을 고용하는 것은 예산 증액의 자연스러운 결과로써 일반적인 비즈니스 활동으로 볼 수 있습니다. A: 'to hire'는 부정사 형태로, 이 문맥에서는 적절하지 않습니다. C: 'hire'는 동사 원형으로, 'means' 뒤에는 동명사가 필요합니다. D: 'hired'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "예산을 증액하는 것은 프로젝트를 위한 추가 직원을 고용하는 것을 의미한다.",
    type: "gerund-infinitive",
  },
  {
    id: 35,
    koreanQuestion:
      "높은 비용 때문에, 회사는 결정했다 중단하기로 _____  불필요한 서비스",
    question:
      "Due to high costs, the company decided to stop ______ unnecessary services.",
    choices: {
      A: "to offer",
      B: "offering",
      C: "offer",
      D: "offered",
    },
    correctAnswer: "B",
    explanation:
      "B: 'offering'은 동명사 형태입니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 'stop' 뒤에 동명사가 오면 '~하는 것을 멈추다'라는 의미가 됩니다. A: 'to offer'는 부정사 형태로, 'stop' 뒤에 부정사가 오면 '~하기 위해 멈추다'라는 의미가 되어 이 문맥에서는 적절하지 않습니다. C: 'offer'는 동사 원형으로, 'stop' 뒤에는 부정사나 동명사가 필요합니다. D: 'offered'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "높은 비용 때문에, 회사는 불필요한 서비스를 제공하는 것을 중단하기로 결정했다.",
    type: "gerund-infinitive",
  },
  {
    id: 36,
    koreanQuestion: "기술자는 시도했다 _____ 시스템을 재시작함으로써 서버를",
    question:
      "The technician tried ______ the system by restarting the server.",
    choices: {
      A: "to fix",
      B: "fixing",
      C: "fix",
      D: "fixed",
    },
    correctAnswer: "B",
    explanation:
      "B: 'fixing'은 동명사 형태입니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 'try' 뒤에 동명사가 오면 '시도해보다'라는 의미가 됩니다. A: 'to fix'는 부정사 형태로, 'try' 뒤에 부정사가 오면 '노력하다'라는 의미가 되어 이 문맥에서는 적절하지 않습니다. C: 'fix'는 동사 원형으로, 'try' 뒤에는 부정사나 동명사가 필요합니다. D: 'fixed'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "기술자는 서버를 재부팅하여 시스템을 고치는 것을 시도했다.",
    type: "gerund-infinitive",
  },
  {
    id: 37,
    koreanQuestion: "나는 절대 잊지 못할 것이다 _____ 에펠탑을 처음으로",
    question: "I'll never forget ______ the Eiffel Tower for the first time.",
    choices: {
      A: "to visit",
      B: "visiting",
      C: "visit",
      D: "visited",
    },
    correctAnswer: "B",
    explanation:
      "B: 'visiting'은 동명사 형태입니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 'forget' 뒤에 동명사가 오면 '이미 했던 일을 잊다'라는 의미가 됩니다. A: 'to visit'는 부정사 형태로, 'forget' 뒤에 부정사가 오면 '해야 할 일을 잊다'라는 의미가 되어 이 문맥에서는 적절하지 않습니다. C: 'visit'는 동사 원형으로, 'forget' 뒤에는 부정사나 동명사가 필요합니다. D: 'visited'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation: "나는 처음으로 에펠탑을 방문했던 것을 절대 잊지 못할 것이다.",
    type: "gerund-infinitive",
  },

  {
    id: 38,
    koreanQuestion: "직원은 후회했다 ____ 이메일을 더블체킹 없이 수신자 주소를",
    question:
      "The employee regretted ______ the email without double-checking the recipient's address.",
    choices: {
      A: "to send",
      B: "sending",
      C: "send",
      D: "sent",
    },
    correctAnswer: "B",
    explanation:
      "B: 'sending'은 동명사 형태입니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 'regret' 뒤에 동명사가 오면 '이미 한 일을 후회하다'라는 의미가 됩니다. A: 'to send'는 부정사 형태로, 'regret' 뒤에 부정사가 오면 '앞으로 할 일을 후회하다'라는 의미가 되어 이 문맥에서는 적절하지 않습니다. C: 'send'는 동사 원형으로, 'regret' 뒤에는 부정사나 동명사가 필요합니다. D: 'sent'는 과거분사로, 문법적으로 맞지 않습니다.",
    translation:
      "직원은 수신자 주소를 다시 확인하지 않고 이메일을 보낸 것을 후회했다.",
    type: "gerund-infinitive",
  },
  {
    id: 39,
    koreanQuestion: "확장하는것 국제시장으로 의미한다 _____ 추가적인 위험을",
    question:
      "Expanding into international markets means ______ additional risks.",
    choices: {
      A: "to take",
      B: "taking",
      C: "take",
      D: "took",
    },
    correctAnswer: "B",
    explanation:
      "B: 'taking'은 동명사 형태입니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. 'mean' 뒤에는 동명사가 자연스럽게 사용됩니다. A: 'to take'는 부정사 형태로, 이 문맥에서는 적절하지 않습니다. C: 'take'는 동사 원형으로, 'mean' 뒤에는 부정사나 동명사가 필요합니다. D: 'took'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation:
      "국제 시장으로의 확장은 추가적인 위험을 감수하는 것을 의미한다.",
    type: "gerund-infinitive",
  },

  {
    id: 40,
    koreanQuestion: "팀은 고군분투했다 ____  소프트웨어를 마감일 전에",
    question: "The team struggled ______ the software before the deadline.",
    choices: {
      A: "to complete",
      B: "completing",
      C: "complete",
      D: "to completing",
    },
    correctAnswer: "A",
    explanation:
      "A: 'to complete'는 부정사 형태입니다. 'struggle'과 같은 동사 뒤에는 목표나 의도를 나타내는 부정사가 자연스럽게 사용됩니다. 아직 이루지 않은 목표, 의도, 미래 지향적인 행동을 나타낼 때는 to 부정사를 사용합니다. B: 'completing'은 동명사 형태로, 'struggle' 뒤에는 부정사가 더 적절합니다. C: 'complete'는 동사 원형으로, 'struggle' 뒤에는 부정사나 동명사가 필요합니다. D: 'to completing'은 문법적으로 맞지 않는 형태입니다.",
    translation: "팀은 마감일 전에 소프트웨어를 완성하려고 애썼다.",
    type: "gerund-infinitive",
  },
  {
    id: 41,
    koreanQuestion:
      "CEO는 부인했다 _____ 어떤 연관을 재정 스캔들에 기자 회견에서",
    question:
      "The CEO denied ______ any involvement in the financial scandal during the press conference.",
    choices: {
      A: "to have",
      B: "having",
      C: "to having",
      D: "have",
    },
    correctAnswer: "B",
    explanation:
      "B: 'having'은 동명사 형태입니다. 'deny'와 같은 동사 뒤에는 동명사가 사용됩니다. 이미 진행 중이거나 경험한 것, 일반적인 활동일 경우 동명사를 씁니다. A: 'to have'는 부정사 형태로, 'deny' 뒤에는 적절하지 않습니다. C: 'to having'은 문법적으로 맞지 않는 형태입니다. D: 'have'는 동사 원형으로, 'deny' 뒤에는 동명사가 필요합니다.",
    translation: "CEO는 기자 회견에서 재정 스캔들에 연루된 사실을 부인했다.",
    type: "gerund-infinitive",
  },
  {
    id: 42,
    koreanQuestion: "직원들은 기뻤다 _____ 그... 그들의 급여가 인상될 것이라는",
    question:
      "The employees were happy ______ that their salaries would be increased.",
    choices: {
      A: "hearing",
      B: "to hear",
      C: "hear",
      D: "heard",
    },
    correctAnswer: "B",
    explanation:
      "B: 'to hear'는 부정사 형태입니다. 감정이나 상태를 나타내는 형용사(happy, glad, pleased 등) 뒤에는 그 감정의 원인이나 이유를 설명할 때 부정사가 사용됩니다. A: 'hearing'은 동명사 형태로, 이 문맥에서는 적절하지 않습니다. C: 'hear'는 동사 원형으로, 형용사 뒤에 바로 사용할 수 없습니다. D: 'heard'는 과거형으로, 문법적으로 맞지 않습니다.",
    translation: "직원들은 그들의 급여가 인상될 것이라는 소식을 들어서 기뻤다.",
    type: "gerund-infinitive",
  },
  {
    id: 43,
    koreanQuestion: "팀은 준비가 되어있다 _____ 프레젠테이션을 투자자들을 위한",
    question: "The team is ready ______ the presentation for the investors.",
    choices: {
      A: "to deliver",
      B: "delivering",
      C: "delivered",
      D: "deliver",
    },
    correctAnswer: "A",
    explanation:
      "A: 'to deliver'는 부정사 형태입니다. 'ready'와 같은 형용사 뒤에는 미래에 할 행동이나 의도를 나타내는 부정사가 자연스럽게 사용됩니다. 아직 이루지 않은 목표, 의도, 미래 지향적인 행동을 나타낼 때는 to 부정사를 사용합니다. B: 'delivering'은 동명사 형태로, 'ready' 뒤에는 부정사가 더 적절합니다. C: 'delivered'는 과거분사로, 이 문맥에서는 맞지 않습니다. D: 'deliver'는 동사 원형으로, 형용사 뒤에 바로 사용할 수 없습니다.",
    translation: "팀은 투자자들을 위한 프레젠테이션을 할 준비가 되어있다.",
    type: "gerund-infinitive",
  },

  {
    id: 44,
    koreanQuestion: "매니저는 주저했다 _____ 최종 결정을 상의 없이 팀과",
    question:
      "The manager was reluctant ______ a final decision without consulting the team.",
    choices: {
      A: "making",
      B: "to make",
      C: "make",
      D: "made",
    },
    correctAnswer: "B",
    explanation:
      "B: 'to make'는 부정사 형태입니다. 'reluctant(주저하는)'와 같은 형용사 뒤에는 미래에 할 행동이나 의도를 나타내는 부정사가 자연스럽게 사용됩니다. 아직 이루지 않은 목표, 의도, 미래 지향적인 행동을 나타낼 때는 to 부정사를 사용합니다. A: 'making'은 동명사 형태로, 'reluctant' 뒤에는 부정사가 더 적절합니다. C: 'make'는 동사 원형으로, 형용사 뒤에 바로 사용할 수 없습니다. D: 'made'는 과거형으로, 이 문맥에서는 맞지 않습니다.",
    translation:
      "매니저는 팀과 상의하지 않고 최종 결정을 내리는 것을 주저했다.",
    type: "gerund-infinitive",
  },

  {
    id: 45,
    koreanQuestion: "주요 목표는 프로젝트 _____  더 효율적인 공급망을",
    question:
      "The main goal of the project is ______ a more efficient supply chain.",
    choices: {
      A: "improving",
      B: "to improve",
      C: "improve",
      D: "improved",
    },
    correctAnswer: "B",
    explanation:
      "B: 'to improve'는 부정사 형태입니다. 'is'와 같은 동사 뒤에 목표나 의도를 나타낼 때 부정사가 자연스럽게 사용됩니다. 아직 이루지 않은 목표, 의도, 미래 지향적인 행동을 나타낼 때는 to 부정사를 사용합니다. A: 'improving'은 동명사 형태로, 이 문맥에서는 부정사가 더 적절합니다. C: 'improve'는 동사 원형으로, 이 구조에서는 사용할 수 없습니다. D: 'improved'는 과거분사로, 이 문맥에서는 맞지 않습니다.",
    translation: "프로젝트의 주요 목표는 더 효율적인 공급망을 개선하는 것이다.",
    type: "gerund-infinitive",
  },

  {
    id: 46,
    koreanQuestion:
      "그것은 도전적이다 _____ 새로운 시장에 강력한 재무 전략 없이",
    question:
      "It is challenging ______ a new market without a strong financial strategy.",
    choices: {
      A: "entering",
      B: "to enter",
      C: "enter",
      D: "entered",
    },
    correctAnswer: "B",
    explanation:
      "B: 'to enter'는 부정사 형태입니다. 'challenging(도전적인)'과 같은 형용사 뒤에는 미래에 할 행동이나 의도를 나타내는 부정사가 자연스럽게 사용됩니다. 아직 이루지 않은 목표, 의도, 미래 지향적인 행동을 나타낼 때는 to 부정사를 사용합니다. A: 'entering'은 동명사 형태로, 'challenging' 뒤에는 부정사가 더 적절합니다. C: 'enter'는 동사 원형으로, 형용사 뒤에 바로 사용할 수 없습니다. D: 'entered'는 과거형으로, 이 문맥에서는 맞지 않습니다.",
    translation:
      "강력한 재무 전략 없이 새로운 시장에 진입하는 것은 도전적이다.",
    type: "gerund-infinitive",
  },

  // 더 많은 문제들 추가...
];
